import type { ElasticListVehicleOdometerReading } from '../app/api/search/vehicles';
import type { Locale, Market } from '../config/domain-locale-map';

export const getAssignmentOdometerUnit = (market: Market): 'km' | 'mil' => {
  switch (market) {
    case 'drive':
      return 'km';
    default:
      return 'mil';
  }
};

interface MileageToOdometerOptions {
  market: Market;
  locale?: Locale;
}

export enum OdometerReadingUnit {
  ScandinavianMiles = 'ScandinavianMiles',
  Kilometer = 'Kilometer',
}

export const odometerReadingUnitByMarket = {
  wayke: OdometerReadingUnit.ScandinavianMiles,
  drive: OdometerReadingUnit.Kilometer,
};

export const mileageToOdometer = (
  mileage: number,
  options: MileageToOdometerOptions,
): ElasticListVehicleOdometerReading => {
  if (options.locale) {
    switch (options.locale) {
      case 'sv':
        return {
          source: '',
          unit: OdometerReadingUnit.Kilometer,
          updatedAt: '',
          value: mileage,
        };
      case 'nb':
        return {
          source: '',
          unit: OdometerReadingUnit.ScandinavianMiles,
          updatedAt: '',
          value: mileage * 10,
        };
      default:
        throw new Error(`Unsupported locale: ${options.locale}`);
    }
  }

  switch (options.market) {
    case 'wayke':
      return {
        source: '',
        unit: OdometerReadingUnit.Kilometer,
        updatedAt: '',
        value: mileage,
      };
    default:
      return {
        source: '',
        unit: OdometerReadingUnit.ScandinavianMiles,
        updatedAt: '',
        value: mileage * 10,
      };
  }
};
